/**
 * Quarterly Objectives Tab — thin wrapper around ObjectivesBBTab
 *
 * Exists for backward compatibility. All logic lives in ObjectivesBBTab.tsx.
 */

import { ObjectivesBBTab, OBJECTIVES_BB_CONFIGS } from "./ObjectivesBBTab";
import type { AllBuildingBlocks, VisibilityMap } from "../types";

interface QuarterlyObjectivesTabProps {
  sessionId: string;
  buildingBlocks: AllBuildingBlocks;
  isAdvisorOrOwner?: boolean;
  currentUserId?: string;
  companyName?: string;
  viewMode?: "solo" | "team";
  onViewModeChange?: (v: "solo" | "team") => void;
  onSessionRefresh?: () => void;
  onReportCreated?: () => void;
  visibilityMap?: VisibilityMap;
  onVisibilityChange?: (updatedMap: VisibilityMap) => void;
}

export function QuarterlyObjectivesTab(props: QuarterlyObjectivesTabProps) {
  return <ObjectivesBBTab config={OBJECTIVES_BB_CONFIGS.quarterlyObjectives} {...props} />;
}

export { QuarterlyObjectivesTab as NextQuarterObjectivesTab };
